import { Stack, Text, DataList, DataItem } from '@cad-arc';
import { DispositionDto } from '@mark43/cad-api';
import { formatMonthDayYearHoursMinutes } from '../../../common/helpers/utils';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';

type DispositionLogProps = { disposition: DispositionDto; isActiveUnitDisposition?: boolean };
export const DispositionLog = ({ disposition, isActiveUnitDisposition }: DispositionLogProps) => {
    const { unitLevelDispositionsEnabled } = useEnabledFeatures();

    const shouldShowPrimaryDisposition =
        unitLevelDispositionsEnabled && isActiveUnitDisposition
            ? true
            : !!disposition.primaryDisposition;

    const shouldShowAdditionalDispositions =
        unitLevelDispositionsEnabled && isActiveUnitDisposition
            ? disposition.additionalDispositions.length
            : // once reached here, it's a history disposition log
              // If there's a primary disposition, this indicates that we have a
              // 'clearing' event, and we'll also want to show the additional disposition,
              // even if it's just blank.
              // If there's a 'reactivation' event, we wont' have either disposition;
              // we'll only have comments
              !!disposition.primaryDisposition;

    return (
        <Stack spacing={1}>
            <Stack justifyContent="space-between" direction="row">
                <Text fontSize="sm" fontWeight="bold">
                    {disposition.title}
                </Text>

                <Text variant="caption" fontFamily="mono" color="tertiary">
                    {[
                        formatMonthDayYearHoursMinutes(disposition.createdDateUtc),
                        disposition.userInitials,
                    ]
                        .filter(Boolean)
                        .join(' ')}
                </Text>
            </Stack>
            <DataList spacing={1}>
                {shouldShowPrimaryDisposition && (
                    <DataItem dataKey="Primary Disposition">
                        {disposition.primaryDisposition}
                    </DataItem>
                )}
                {shouldShowAdditionalDispositions && (
                    <DataItem dataKey="Additional Disposition">
                        {disposition.additionalDispositions.length
                            ? disposition.additionalDispositions.join(', ')
                            : undefined}
                    </DataItem>
                )}
                <DataItem spacing={0} dataKey={`${disposition.commentsTitle}:`} variant="stacked">
                    {disposition.comments}
                </DataItem>
            </DataList>
        </Stack>
    );
};
